package com.nonopn.skywatcher.design.widgets

import androidx.compose.foundation.background
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.graphics.Color
import com.nonopn.skywatcher.design.theme.AppColor
import eu.codlab.compose.theme.LocalDarkTheme

fun Modifier.defaultBackground() = composed {
    /*this.background(
        if (LocalDarkTheme.current) {
            AppColor.BackgroundBlue
        } else {
            AppColor.GrayExtraLight // gray hyper light
        }
    )*/
    this
}

fun Modifier.defaultCardBackground() = composed {
    this.background(
        if (LocalDarkTheme.current) {
            AppColor.BackgroundBlue
        } else {
            AppColor.White
        }
    )
}

@Composable
fun defaultCardBackground(isSelected: Boolean = false): Color = when {
    isSelected -> if (LocalDarkTheme.current) {
        AppColor.BackgroundBlue
    } else {
        AppColor.GrayLight
    }

    LocalDarkTheme.current -> AppColor.BackgroundLightBlue
    else -> AppColor.WhiteCream
}

@Composable
fun defaultScrollBackground() = if (LocalDarkTheme.current) {
    AppColor.BackgroundBlue
} else {
    AppColor.GrayLight
}

@Composable
fun defaultSecondaryCardBackground(isSelected: Boolean = false): Color =
    when {
        isSelected -> {
            if (LocalDarkTheme.current) {
                AppColor.BackgroundBlue
            } else {
                AppColor.Gray
            }
        }

        LocalDarkTheme.current -> AppColor.BackgroundBlue
        else -> AppColor.White
    }
